/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge21 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<path fill={fill}  d="M268.6,27.4c2,0,3.9,0,5.9,0c13.5-0.3,27-0.3,40.4,0.4c11.9,0.6,23.9,0.5,35.8,0.6c6,0,11.9,0.3,17.9,0.3
				c6.8,0.1,13.6,0.1,20.4,0.1c1.5,0,3.1,0,4.6,0c0.6,0,1.3,0.1,1.4,0.9c0.1,0.8-0.5,1-1.2,1.1c-0.8,0.1-1.6,0.2-2.4,0.3
				c-9,1-18,1.3-27.1,1.3c-7,0-14,0.1-21,0.2c-12.1,0.2-24.3-0.4-36.4-1.1c-3.7-0.2-7.4-0.3-11.1-0.3c-4.1-0.1-8.2,0-12.3-0.1
				c-4.9,0-9.9,0.1-14.7-0.5c-0.4,0.8,0.1,1,0.5,1.3c0.7,0.7,1.4,1.2,1.9,2c0.4,0.8,0.3,1.6-0.4,2.2c-0.6,0.5-1.3,0.7-2,0.3
				c-1.8-1.2-3.5-2.5-5-4.1c-1-1.1-1-2.7,0.1-4c2-2.2,3.7-4.7,6.1-6.5c0.2-0.2,0.5-0.4,0.8-0.2c0.4,0.3,0.4,0.7,0.2,1.1
				c-0.3,0.5-0.6,1.1-0.9,1.6C269.4,25.4,268.7,26.3,268.6,27.4z"/>
			<path fill={fill}  d="M103.7,30.6c0.1-0.8,0.6-0.7,1-0.8c8-1.1,15.9-1.9,24-1.3c6.2,0.4,12.3,0.8,18.5,1.2c9.9,0.6,19.7,1,29.6,1.3
				c10.4,0.4,20.8,0.4,31.1-0.3c3.1-0.2,6.2-0.5,9.2-0.7c0.6-0.1,1.3,0,1.7-0.7c-0.7-0.9-1.5-1.9-2.2-2.9c-0.3-0.4-0.4-0.9-0.5-1.4
				c-0.1-0.4,0.8-1,1.1-0.8c2.3,1.6,4.5,3.1,6.9,4.6c1,0.6,1.2,1.9,0.5,3.1c-0.4,0.7-0.8,1.4-1.4,2c-0.7,0.9-1.5,1.7-2.3,2.5
				c-1.1,1.2-2,1.4-3,0.9c-1.2-0.7-1.3-1.7-1-2.9c0.1-0.3,0.1-0.6,0.1-1c-3.1,0.2-6.2,0.4-9.3,0.7c-7.7,0.7-15.4,0.6-23.1,0.4
				c-7-0.2-14-0.4-21-0.7c-10.2-0.5-20.3-1.2-30.5-2.1c-8.9-0.7-17.9-0.9-26.8-0.8C105.6,30.8,104.6,31,103.7,30.6z"/>
			<path fill={fill}  d="M243.1,17.3c1.4,0,2.7,0.5,4.1,0.9c1.5,0.4,2.8,0.7,4-1c0.9-1.3,2.5-2.1,4.1-2.7c1.3-0.4,2.5-0.4,3.4,0.6
				c0.9,0.9,0.8,2.1,0.4,3.2c-0.7,1.8-1.5,3.6-2.6,5.2c-0.6,0.9-1,1.7-1,2.8c-0.1,3.4-1.7,6.3-3.2,9.2c-0.8,1.5-2.1,2.5-3.7,3.1
				c-3,1.2-6,1.5-9,0.1c-1-0.5-1.8-0.5-2.8,0c-1.8,1-3.8,1.6-5.9,1.8c-1,0.1-2,0.1-3-0.3c-2.2-0.8-2.8-2.2-1.7-4.3
				c0.6-1.1,1.3-2.1,2.2-2.9c0.9-0.9,1.9-1.9,2.9-2.8c0.5-0.5,0.7-0.9,0.5-1.6c-1.2-3.5,0.4-6,3-8C237.3,18.7,239.9,17.4,243.1,17.3z
				M234.9,27.2c-0.1,2.4,0.8,4.3,2.1,6.1c0.5,0.7,1.1,0.9,1.8,0.4c4-2.5,8-5,11.3-8.4c0.5-0.6,0.5-1,0-1.6c-1.5-1.9-3.5-3.1-5.9-3.5
				c-2.6-0.4-4.7,0.9-7,1.8c-0.2,0.1-0.3,0.3-0.4,0.4C235.3,23.7,234.7,25.4,234.9,27.2z M241.6,36c7.5,0.8,10.7-1.9,9.9-7.7
				c-0.3,0.1-0.6,0.2-0.8,0.3C247.8,30.9,245.2,33.6,241.6,36z M235.2,35.4c-0.6-1-1.2-2.1-1.8-3.1c-2.6,2.1-2.9,2.4-3.2,4.6
				C232,36.7,233.7,36.4,235.2,35.4z M253.9,21.3c0.9-0.3,1.2-1,1.5-1.8c0.1-0.3,0.1-0.6-0.1-0.8c-0.3-0.4-0.7-0.3-1.1-0.2
				c-0.7,0.3-1.5,0.6-1.9,1.4C252.8,20.5,253.3,21,253.9,21.3z"/>
			<path fill={fill}  d="M257.2,42.6c-1.6,0-3-1.1-3.1-2.4c-0.1-1.4,1.4-3,2.9-2.9c1.6,0.1,3.1,1.4,3.1,2.8C260.1,41.6,258.9,42.6,257.2,42.6z"/>
			<path fill={fill}  d="M103.9,23.7c-0.1,0.2-0.1,0.4-0.2,0.6c-1.4,2-2.7,4.1-4.2,6c-0.4,0.6-1,1-1.5,1.5c-0.4,0.3-1,0.3-1.4-0.1
				c-0.5-0.4-0.7-1-0.4-1.6c0.1-0.2,0.2-0.4,0.3-0.5c2.2-2.1,4.5-4.1,6.8-6.2c0.1-0.1,0.4,0,0.5,0.1C103.9,23.4,103.9,23.6,103.9,23.7z
				"/>
			<path fill={fill}  d="M411.6,26.7c-0.5,2.3-1.3,4.1-2.1,5.8c-0.2,0.4-0.4,0.8-0.6,1.1c-0.5,0.6-1.1,0.9-1.9,0.5c-0.7-0.4-1.2-1-0.9-1.8
				c0.8-2,1.5-4.1,3.8-4.9C410.3,27.2,410.8,27,411.6,26.7z"/>
			<path fill={fill}  d="M91.1,30.6c-0.5,0-1-0.9-0.7-1.4c0.3-0.5,0.7-1,1.1-1.4c1.9-1.7,3.8-3.4,5.8-5.1c0.2-0.2,0.5-0.4,0.8-0.1
				c0.2,0.2,0.1,0.5-0.1,0.8c-1.7,2.1-3.5,4.3-5.2,6.4C92.4,30.2,91.9,30.7,91.1,30.6z"/>
			<path fill={fill}  d="M403.4,25.8c0,0.2,0.1,0.4,0,0.6c-0.5,1.5-1.1,3.1-1.7,4.6c-0.2,0.5-0.6,0.9-1.2,0.7c-0.7-0.2-1-0.8-0.9-1.4
				c0.2-0.9,0.5-1.8,1-2.5c0.6-0.8,1.4-1.5,2.1-2.2c0.1-0.1,0.4,0,0.5,0C403.3,25.5,403.3,25.7,403.4,25.8z"/>
			<path fill={fill}  d="M228.6,20.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.8,0.5-1.3,1.2-1.6c0.7-0.3,1.4-0.1,1.9,0.5c0.6,0.7,0.3,1.6-0.5,1.9
				C229.5,19.8,229,20,228.6,20.1z"/>
			<path fill={fill}  d="M243.9,10.4c0.2,0-0.1,0.1-0.3-0.1c-0.2-0.1-0.5-0.5-0.4-0.7c0-0.2,0.3-0.5,0.5-0.7c0.3-0.2,0.7-0.3,1.1-0.1
				c0.5,0.3,0.9,0.6,0.7,1.2C245.3,10.4,244.8,10.5,243.9,10.4z"/>
			<path fill={fill}  d="M264.3,13.6c-0.2-0.1-0.6-0.2-0.6-0.5c-0.1-0.2,0.1-0.6,0.3-0.8c0.4-0.4,0.9-0.6,1.4-0.3c0.2,0.1,0.5,0.4,0.6,0.6
				c0.1,0.3-0.1,0.6-0.4,0.7C265.1,13.5,264.7,13.6,264.3,13.6z"/>
			<path fill={fill}  d="M259.5,22.7c0-0.6,0.5-0.7,1-0.8c0.1,0,0.3,0.2,0.3,0.4c0.1,0.6-0.3,0.9-0.8,1.1C259.8,23.4,259.6,23.1,259.5,22.7z"/>
			<path fill={"#FF779F"} d="M234.9,27.2c-0.1-1.8,0.5-3.4,1.9-4.8c0.1-0.1,0.3-0.3,0.4-0.4c2.3-0.9,4.4-2.2,7-1.8c2.4,0.4,4.4,1.6,5.9,3.5
				c0.4,0.5,0.5,1,0,1.6c-3.3,3.4-7.3,5.9-11.3,8.4c-0.7,0.5-1.3,0.3-1.8-0.4C235.7,31.5,234.7,29.6,234.9,27.2z"/>
			<path fill={"#FF779F"} d="M241.6,36c3.7-2.4,6.2-5.1,9.1-7.3c0.2-0.2,0.5-0.2,0.8-0.3C252.3,34,249.1,36.8,241.6,36z"/>
			<path fill={fill}  d="M237.2,46c-0.2-0.1-0.4-0.1-0.6-0.2c-0.7-0.4-1.1-0.9-1.1-1.7c0-1.1,1.2-2.4,2.3-2.6c0.8-0.1,1.4,0.2,1.9,0.8
				c0.2,0.3,0.4,0.8,0.4,1.1C240.1,44.6,238.4,46.1,237.2,46z"/>
		</svg>
	</div>
}

